export const partnerPath = (organization_id) => {
  return `/partners/${organization_id}`
}
